export const parking_service = {
  key: "parking_service",
  icon: "parking_service_icon.svg",
  i18n_name: "parking_service.name",
  i18n_tooltip: "parking_service.tooltip",
  i18n_description: "parking_service.description",
};

export const shuttle_service = {
  key: "shuttle_service",
  icon: "shuttle_icon.svg",
  i18n_name: "shuttle_service.name",
  i18n_tooltip: "shuttle_service.tooltip",
  i18n_description: "shuttle_service.description",
};

export const wheels_service = {
  key: "wheels_service",
  icon: "wheels_icon.svg",
  i18n_name: "wheels_service.name",
  i18n_tooltip: "wheels_service.tooltip",
  i18n_description: "wheels_service.description",
};

export const package_service = {
  key: "package_service",
  icon: "package_icon.svg",
  i18n_name: "packages_service.name",
  i18n_tooltip: "packages_service.tooltip",
  i18n_description: "packages_service.description",
};

export const travel_club_service = {
  key: "travel_club_service",
  icon: "travel_club_icon.svg",
  i18n_name: "travel_club_service.name",
  i18n_tooltip: "travel_club_service.tooltip",
  i18n_description: "travel_club_service.description",
};

export const services = [
  parking_service,
  shuttle_service,
  wheels_service,
  package_service,
  travel_club_service,
];
